import React, { useState } from 'react';
import translations from '../../translations.json';
import { addCommas, getCompanyLogo, getCompanyName, getProductType } from "../utils";
import arrowDown from './arrow-down.svg';
import arrowLeft from './arrow-left.svg';
import arrow from './arrow.svg';
import './mainContent.scss';
import noChange from './no-change.svg';
import star from './star.svg';

interface MainContentProps {
    data: any;    
    state: any;    
}



const MainContentV2: React.FC<MainContentProps> = ({
    data,    
    state,    
}) => {
    // State to track which products have expanded details
    const [expandedProducts, setExpandedProducts] = useState<Set<number>>(new Set());

    // Function to toggle details visibility for a specific product
    const toggleProductDetails = (productIndex: number) => {
        setExpandedProducts(prev => {
            const newSet = new Set(prev);
            if (newSet.has(productIndex)) {
                newSet.delete(productIndex);
            } else {
                newSet.add(productIndex);
            }
            return newSet;
        });
    };

    const getProductText = (product: any) => {

        if (product.newProduct.action === 'unchanged') {
            return `${getProductType(product.oldProduct)} ב${getCompanyName(product.oldProduct)} - ללא שינוי`;
        }

        if (product.newProduct.action === 'agentAssignment') {
            // return `העברת ${getProductType(product.oldProduct)} ל${getProductType(product.newProduct)} בחברת ${getCompanyName(product.newProduct)}`
            return `מינוי Better כסוכן מטפל ב${getProductType(product.oldProduct)} ב${getCompanyName(product.newProduct)}`;
        }        
        if (product.newProduct.productType !== product.oldProduct.productType) {
            return `העברת ${getProductType(product.oldProduct)} ל${getProductType(product.newProduct)} בחברת ${getCompanyName(product.newProduct)}`
        }
        if (product.newProduct.companyName !== product.oldProduct.companyName) {
            return `העברת ${getProductType(product.newProduct)} לחברת ${getCompanyName(product.newProduct)}`
        }
        return `פתיחת ${getProductType(product.newProduct)} ב${getCompanyName(product.newProduct)}`
    }

    const getTitle = (product: any) => {    
        // debugger;
        return getProductType(product.oldProduct);
    }

    const getLogoClass = (product: any) => {        
        let logoClass = product.oldProduct.companyShortName === product.newProduct.companyShortName ? 'logo' : 'logo old';
        if (getCompanyLogo(product.oldProduct) && !["unchanged", "agentAssignment"].includes(product.newProduct.action)) {
            logoClass += ' greyscale';
        }
        return logoClass;
    }
    // Sort products by category and then by active/inactive status
    const sortedProducts = state?.products ? [...state.products].sort((a: any, b: any) => {
        // Define product type priority order
        const productTypePriority: { [key: string]: number } = {
            'comprehensivePensionFund': 1,
            'complementaryPensionFund': 2,
            'directorsInsurance': 3,
            'studyFund': 4,
            'providentFund': 5,
            'investmentFund': 6
        };
        
        // Get product types (use oldProduct as it always exists)
        const aType = a.oldProduct.productType;
        const bType = b.oldProduct.productType;
        
        // Get priority for each product (default to 999 if not found)
        const aPriority = productTypePriority[aType] || 999;
        const bPriority = productTypePriority[bType] || 999;
        
        // First, sort by product type category
        if (aPriority !== bPriority) {
            return aPriority - bPriority;
        }
        
        // Within same category, sort by active/inactive status
        // Active products (action !== 'unchanged') come before inactive (action === 'unchanged')
        const aIsActive = a.newProduct.action !== 'unchanged';
        const bIsActive = b.newProduct.action !== 'unchanged';
        
        if (aIsActive && !bIsActive) {
            return -1; // a goes before b
        }
        if (!aIsActive && bIsActive) {
            return 1; // a goes after b
        }
        
        return 0; // maintain order
    }) : [];

    return (
        <div className="content-v2">
            <div className="hi-user">היי {data?.clientName}!</div>
            <div className="texts">
                <div className="text1">
                    בהמשך לשיחתנו, איתרנו לך חיסכון משמעותי בפנסיה, קופות גמל וקרנות השתלמות!                                
                </div>
                <div className="text2">
                    {data?.gender === 'female' ? 'לחצי' : 'לחץ'} על הכפתור מטה כדי לאשר את ביצוע הפעולה ולחתום על הטפסים הנדרשים
                </div>
                <div className="text3">
                    הנה פירוט הפעולות שנבצע עבורך  {" "}
                    
                </div>
            </div>
            
            
            <div>
                <div className="saving-details">                                    
                    {sortedProducts.map((product: any, index: number) => {
                        // Check if this is the first item in its product type group
                        const isFirstInGroup = index === 0 || 
                            sortedProducts[index - 1].oldProduct.productType !== product.oldProduct.productType;
                        
                        // Check if this is the last item in its product type group
                        const isLastInGroup = index === sortedProducts.length - 1 || 
                            sortedProducts[index + 1].oldProduct.productType !== product.oldProduct.productType;
                        
                        return (
                            <div key={index} className="product-item">
                                {isFirstInGroup && <div className="title">{getTitle(product)}</div>}
                                <div className="content">
                                    <div className="main-line">
                                        <span className={getLogoClass(product)}>
                                            {product.newProduct.action === "newProduct" ? 
                                            <span className="agent-assignment-text">מוצר חדש</span> :
                                            
                                            <span className="logo-img">{getCompanyLogo(product.oldProduct)?<img src={getCompanyLogo(product.oldProduct)} alt={getCompanyName(product.oldProduct)} />:<span>{getCompanyName(product.oldProduct)}</span>}</span>
                                            
                                        }
                                                                                   
                                        </span>                                    
                                            <span className="arrow"><img src={arrow} alt="arrow" /></span>
                                        
                                        {product.newProduct.action === "unchanged" ? <span className="logo status-no-change">
                                            <img src={noChange} alt="ללא שינוי" />
                                            ללא שינוי
                                            </span>:
                                        product.newProduct.action === "agentAssignment"?
                                        <span className="logo status-agent-assignment">
                                        <span className="status-icon">★</span>
                                        מינוי סוכן
                                        </span>: 
                                        getCompanyLogo(product.newProduct)?
                                        <span>
                                            <span className="logo logo-img">
                                                <img src={getCompanyLogo(product.newProduct)} alt={getCompanyName(product.newProduct)} />
                                                

                                            </span>
                                            {product.newProduct.productType !== product.oldProduct.productType && (
                                                    <div className="product-transfer-text">ניוד ל{getProductType(product.newProduct)}</div>
                                                )}
                                            </span>
                                            :
                                            <span>
                                            <span className={getLogoClass(product)}>
                                                {getCompanyName(product.newProduct)}                                                
                                            </span>
                                            {product.newProduct.productType !== product.oldProduct.productType && (
                                                    <div className="product-transfer-text">ניוד ל{getProductType(product.newProduct)}</div>
                                                )}
                                            </span>
                                        }
                                        
                                        <span className="arrow-down-wrapper">
                                            <span 
                                                className={`arrow-down ${expandedProducts.has(index) ? 'expanded' : ''}`}
                                                onClick={() => toggleProductDetails(index)}
                                            >
                                                <img src={arrowDown} alt="arrow-down" />
                                            </span>
                                        </span>
                                    </div>
                                    <div className={`details ${expandedProducts.has(index) ? 'expanded' : 'collapsed'}`}>
                                        <div className="detail-item">
                                            <div className="title">סכום הצבירה: ₪{addCommas(product.newProduct.totalSavings)}</div>
                                            <div className="item-line">
                                                <span className="item-text">דמי הניהול מהצבירה:</span>
                                                <span className="percentages">
                                                    {!["newProduct","agentAssignment","unchanged"].includes(product.newProduct.action) ? <>
                                                    <span className="percentage textAlignRight">{product.oldProduct.commissions.savings}%</span>
                                                    <span className="left-arrow"><img src={arrowLeft} alt="arrow" /></span>
                                                    </>:<>
                                                    <span className="percentage textAlignRight"></span>
                                                    <span className="left-arrow"></span>
                                                    </>}
                                                    <span className="percentage textAlignLeft"><b>{product.newProduct.commissions.savings}%</b></span>
                                                </span>
                                            </div>
                                        </div>

                                        <div className="detail-item">
                                            <div className="title">הפקדה חודשית: ₪{addCommas(product.newProduct.monthlyDepositAmount || 0)}</div>
                                            <div className="item-line">
                                                <span className="item-text">דמי הניהול מההפקדה</span>
                                                <span className="percentages">
                                                    {!["newProduct","agentAssignment","unchanged"].includes(product.newProduct.action) ? <>
                                                    <span className="percentage textAlignRight">{product.oldProduct.commissions.deposit}%</span>
                                                    <span className="left-arrow"><img src={arrowLeft} alt="arrow" /></span>
                                                    </>:<>
                                                    <span className="percentage textAlignRight"></span>
                                                    <span className="left-arrow"></span>
                                                    </>}
                                                    <span className="percentage textAlignLeft"><b>{product.newProduct.commissions.deposit}%</b></span>
                                                </span>
                                            </div>
                                        </div>

                                        <div className="detail-item">                                        
                                            <div className="item-line policies">
                                                <span className="item-text title">מסלול השקעה</span>
                                                <span className="percentages">
                                                    {!["newProduct","agentAssignment","unchanged"].includes(product.newProduct.action) ? <>
                                                    <span className="percentage textAlignRight">{product.oldProduct.investmentPolicies.map((policy:string) => <div>{translations[policy as keyof typeof translations]}</div>)}</span>
                                                    <span className="left-arrow"><img src={arrowLeft} alt="arrow" /></span>
                                                    </>:<>
                                                    <span className="percentage textAlignRight"></span>
                                                    <span className="left-arrow"></span>
                                                    </>}
                                                    <span className="percentage textAlignLeft"><b>{product.newProduct.investmentPolicies.map((policy:string) => <div>{translations[policy as keyof typeof translations]}</div>)}</b></span>
                                                </span>
                                            </div>
                                        </div>
                                        {/* const oldProduct = {
                    productType: product.productType,
                    companyName: productCompany.name,
                    companyShortName: productCompany.shortName,
                    commissions: product.commissions.percentages,
                    investmentPolicies: oldInvestmentPolicies
                };

                const newProduct = {
                    productType: productTransfer.productType,
                    companyName: productTransferCompany.name,
                    commissions: productTransfer.commissions,
                    companyShortName: productTransferCompany.shortName,
                    action: productTransfer.action,
                    totalSavings: productTransfer.totalSavings,
                    investmentPolicies: productTransfer.investmentPolicies.map(policy => policy.fund?.investmentPolicy)
                }; */}
                                    </div>
                                    {isLastInGroup ? (
                                        <div className="separator"></div>
                                    ) : (
                                        <div className="item-spacer"></div>
                                    )}
                                </div>
                                {/* <img className="checkmark" src={checkmark}/>
                                
                                <img className="info" src={info} onClick={() => setSelectedProduct(product)}/> */}
                            </div>
                        );
                    })}                                 
                </div>                                
            </div>            
        </div>
    );
};

export default MainContentV2;
